const LEVEL_USER = 'USER'
const LEVEL_ADMIN = 'ADMIN'
const LEVEL_OWNER = 'OWNER'

const userAtLeastIs = (user, level) => {
    if(!user || !level) return
    let allow = false
    
    switch (level) {
        case LEVEL_USER:
            allow = user === LEVEL_USER || 
                    user === LEVEL_ADMIN || 
                    user === LEVEL_OWNER
            break;
    
        case LEVEL_ADMIN:
            allow = user === LEVEL_ADMIN || 
                    user === LEVEL_OWNER
            break;
        
        case LEVEL_OWNER:
            allow = user === LEVEL_OWNER
            break;
    }

    return allow
}

export {
    LEVEL_USER,
    LEVEL_ADMIN,
    LEVEL_OWNER,
    userAtLeastIs
}